import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { CopyInspecaoMaquinaEquipForm, CopyInspecaoMaquinaEquipSchema } from "../../../schemas/MaquinasEquipItens_controle/copy_inspecao_maquina_equip";
import { useEffect } from "react";

/**
 * CopyInspecaoMaquinaEquipModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: (form: CopyInspecaoMaquinaEquipForm) => void;
};

export const CopyInspecaoMaquinaEquipModal = ({
  open,
  saving,
  loading,
  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<CopyInspecaoMaquinaEquipForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(CopyInspecaoMaquinaEquipSchema),
  });

  useEffect(() => {
    if (open) { hookForm.reset(); }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Copiar Inspeção"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-2 my-4">
        <FormMaskedInput
          name='nroCopias'
          label='Número de Cópias'
          mask='00'
          maskPlaceholder='__'
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}